"use client";

import {
  isLoggedInRetailerOrBrandPreview,
  useIsLoggedInRetailer,
} from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useCategoryStore } from "@faire/deprecated-retailer-visitor-shared/stores/domain/useCategoryStore";
import { LoggedInCategoryPageLoadingSkeleton } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedInCategoryPageLoadingSkeleton";
import { LoggedOutCategoryPageLoadingSkeleton } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/CategoryPageLoadingSkeleton/LoggedOutCategoryPageLoadingSkeleton";
import { CategoryPageRoot } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/CategoryPageRoot";
import { LazyShowroom } from "@faire/deprecated-retailer-visitor-shared/views/category/Showroom/LazyShowroom";
import { IRouteMetadata, Route } from "@faire/web-api--source/Route";
import { props as c1CategoryRouteProps } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId";
import { props as c1CategoryBrandValueRouteProps } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/brand-value/brandValue";
import { props as c2CategoryRouteProps } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId";
import { props as c2CategoryBrandValueRouteProps } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/brand-value/brandValue";
import { props as c3CategoryRouteProps } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId";
import { props as c3CategoryBrandValueRouteProps } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/brand-value/brandValue";
import { props as c4CategoryRouteProps } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId";
import { props as c5CategoryRouteProps } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId/c5CategoryUrlId";
import { props as c6CategoryRouteProps } from "@faire/web-api--source/routes/www/category/c1CategoryUrlId/subcategory/c2CategoryUrlId/c3CategoryUrlId/c4CategoryUrlId/c5CategoryUrlId/c6CategoryUrlId";
import { props as c1CategoryShowroomRouteProps } from "@faire/web-api--source/routes/www/category/Showroom";
import { props as c1SuppliersRouteProps } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId";
import { props as c1SuppliersBrandValueRouteProps } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/brand-value/brandValue";
import { Switch } from "@faire/web/common/routing/Switch";
import { useIsSSR } from "@faire/web/common/server-side-rendering/isSSR";
import React, { Suspense } from "react";

const nLevelCategoryRoutes = (
  includeSuppliersRoutes: boolean
): Array<IRouteMetadata & { path: string }> => [
  // solely for /suppliers/All Brands/brand-value/{brandValue}
  // solely for /suppliers/All Brands
  ...(includeSuppliersRoutes
    ? [c1SuppliersBrandValueRouteProps, c1SuppliersRouteProps]
    : []),
  c3CategoryBrandValueRouteProps,
  c2CategoryBrandValueRouteProps,
  c1CategoryBrandValueRouteProps,
  c6CategoryRouteProps,
  c5CategoryRouteProps,
  c4CategoryRouteProps,
  c3CategoryRouteProps,
  c2CategoryRouteProps,
  c1CategoryRouteProps,
];

export const CategoryRouter: React.FC = () => {
  return <CategoryRouterBase Component={CategoryPageRoot} />;
};

export const CategoryRouterBase = ({
  Component,
}: {
  Component: typeof CategoryPageRoot;
}) => {
  const isSSR = useIsSSR();
  const { categoriesLoading } = useCategoryStore();
  const isLoggedInRetailer = useIsLoggedInRetailer();

  if (isSSR || categoriesLoading) {
    if (!isLoggedInRetailerOrBrandPreview()) {
      return <LoggedOutCategoryPageLoadingSkeleton />;
    }
    return <LoggedInCategoryPageLoadingSkeleton />;
  }
  const categoryRoutes = nLevelCategoryRoutes(isLoggedInRetailer);
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route
          {...c1CategoryShowroomRouteProps}
          exact
          component={LazyShowroom}
        />
        {categoryRoutes.map((route) => (
          <Route {...route} exact key={route.path} component={Component} />
        ))}
      </Switch>
    </Suspense>
  );
};
